import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Column } from '@app/modules/table/classes/column.class';

export class EmployeeCountColumn extends Column {
    title = 'table.departments.employeeCount';
    property = 'employeeCount';
    type: CellDisplay = CellDisplay.string;
}
